import customerServiceTeam from "../../../apps/catalog/data/customerServiceTeam.json";

export class CustomerServiceTeamStaticData {
  static getAll() {
    return customerServiceTeam;
  }
}
